import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { InternalDelinquencyBpoStore } from '../stores/internalDelinquencyBpoStore';

export const useInternalDelinquencyStore = () => useContext<{
  internalDelinquencyBpoStore: InternalDelinquencyBpoStore
}>(StoreContext);